import qconsole from 'scripts/lib/qconsole';

import TeamAssistMessage from 'models/team_assist_message';

export default class TeamAssistGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  getStore(customerId) {
    if (this._isCustomerLoaded(customerId)) {
      return this.context.stores.customers.storesFor(customerId).teamAssists;
    }
    qconsole.log('TeamAssistGatewayObserver: customer not loaded. Ignoring response');
    return null;
  }

  onBroadcast(dto) {
    const store = this.getStore(dto.customerId);
    if (store) {
      store.addOrReplace(TeamAssistMessage.fromJs(dto));
    }
  }

  onFetchAllSuccess(fetchResultDto, { customerId }) {
    const store = this.getStore(customerId);
    if (store) {
      store.resetLoading();
      store.set(fetchResultDto.map(dto => TeamAssistMessage.fromJs(dto)));
    }
  }

  onFetchAllError(err, { customerId }) {
    const store = this.getStore(customerId);
    if (store) {
      store.resetLoading();
    }
    qconsole.log(`TeamAssistGatewayObserver: failed to fetch team assists: ${JSON.stringify(err)}`);
  }

  onAddSuccess(dto, { customerId }) {
    const store = this.getStore(customerId);
    if (store) {
      if (dto.messages) {
        dto.messages.forEach(msg => {
          store.addOrReplace(TeamAssistMessage.fromJs(msg));
        });
      } else {
        store.addOrReplace(TeamAssistMessage.fromJs(dto));
      }
    }
  }

  onAddError(err, { customerId }) {
    qconsole.log(`TeamAssistGatewayObserver: failed to add team assist message: ${JSON.stringify(err)}`);
  }

  onBroadcastDelete(dto, { customerId }) {
    const store = this.getStore(customerId);
    if (store) {
      store.set([]);
    }
  }

  onDeleteSuccess(dto, { customerId }) {
    const store = this.getStore(customerId);
    if (store) {
      store.set([]);
    }
  }

  onDeleteError(err, { customerId }) {
    qconsole.log(`TeamAssistGatewayObserver: failed to clear team assist session: ${JSON.stringify(err)}`);
  }

  onRetryError(err, { customerId, messageId }) {
    qconsole.log(
      `TeamAssistGatewayObserver: failed to retry team assist message [${messageId}] for customer [${customerId}]:`,
      err
    );
    const store = this.getStore(customerId);
    if (store) {
      try {
        const message = store.find(messageId);
        if (message) {
          store.addOrReplace(
            TeamAssistMessage.fromJs({
              ...message.toJs(),
              isRetrying: false,
            })
          );
        }
      } catch (e) {
        // message may already be gone
      }
    }
  }

  onRetrySuccess(dto, { customerId }) {
    const store = this.getStore(customerId);
    if (store) {
      store.addOrReplace(TeamAssistMessage.fromJs(dto));
    }
  }

  _isCustomerLoaded(customerId) {
    return this.context.stores.customers.has({ id: customerId });
  }
}
